import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortUp, faSortDown, faEllipsisV, faTimes ,faPlus , faCheckCircle,faSearch } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import {Loader, Spinner } from '../Loader/Loader';
import { Msg200or201, Msg204, Msg400, Msg401 ,Msg403, Msg500 } from '../Messages/Messages';
// import ProjectReports from '../measurit/ProjectSummary/ProjectReports';
import * as XLSX from 'xlsx';
import Pagination, { usePagination } from '../Components/Pagination';
import Search from '../Components/Search';
import { decryptData } from '../../utils/storageCrypto';
import { FaCoins } from "react-icons/fa";

const BuildCoinLedgers = () => {
  const [ledgers, setLedgers] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupType, setPopupType] = useState('');
  const [errorMessages, setErrorMessages] = useState([]);
  const RETRY_LIMIT = 3; // Maximum number of retries
  const [retryCount, setRetryCount] = useState(0); // Track retry attempts
  const [retryFunction, setRetryFunction] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const backendApiUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const [displayedLedgers, setdisplayedLedgers] = useState([]);
 

const searchTypes = ['Customer Name', 'Mobile', 'Status','Product Category'];

const [persistedSearchQuery, setPersistedSearchQuery] = useState('');
const [persistedSearchType, setPersistedSearchType] = useState('');

const [filterLedgers, setFilterLedgers] = useState([]);

const [searchChips, setSearchChips] = useState(() => {
  const saved = localStorage.getItem('projectSearchChips');
  return saved ? JSON.parse(saved) : [];
});
const [isRefreshing, setIsRefreshing] = useState(false);

useEffect(() => {
  localStorage.setItem('ledgerSearchChips', JSON.stringify(searchChips));
}, [searchChips]);


const {
  currentItems,
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  handlePageChange,
  handlePreviousPage,
  handleNextPage,
  resetToFirstPage
} = usePagination(displayedLedgers, 10);


  const sortArray = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });

    const sortedArray = [...ledgers].sort((a, b) => {
      const aValue = a[key] || ''; // Treat undefined as empty string
      const bValue = b[key] || ''; // Treat undefined as empty string

      // Convert to string for comparison and handle case insensitivity
      const aString = aValue.toString().toLowerCase();
      const bString = bValue.toString().toLowerCase();

      if (aString < bString) {
        return direction === 'ascending' ? -1 : 1;
      }
      if (aString > bString) {
        return direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });

    setLedgers(sortedArray);
    resetToFirstPage();
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'ascending' ? <FontAwesomeIcon icon={faSortUp} /> : <FontAwesomeIcon icon={faSortDown} />;
    }
    return null;
  };

  const enuserData = sessionStorage.getItem('userData');
  const userData = decryptData(enuserData)

  const filterProjects = (projects) => {
    if (!userData || (userData.roleID !== 2 && userData.roleID !== 3)) {
      return projects;
    }

    return projects.filter(project => {
      if (userData.roleID === 2) {
        return project.marketingAssociateId === userData.userId;
      } else if (userData.roleID === 3) {
        return project.fieldAssociateId === userData.userId;
      }
    });
  };


 const handleSearch = (query, type) => {
  const q = (query || '').toLowerCase().trim();

  if (!q || !type) {
    setdisplayedLedgers(ledgers);
    resetToFirstPage();
    return;
  }

  const filtered = ledgers.filter((ledger) => {
    switch (type) {
      case 'Customer Name':
        return ledger.customerName?.toLowerCase().includes(q);
      case 'Mobile':
        return ledger.mobile?.toLowerCase().includes(q);
      case 'Status':
        return ledger.status?.toLowerCase().includes(q);
      case 'Product Category':
        return ledger.productCategory?.toLowerCase().includes(q);
      default:
        return true;
    }
  });

  setdisplayedLedgers(filtered);
  resetToFirstPage();
};


  const handleRemoveSearchChip = (chipToRemove) => {
  const updated = searchChips.filter(
    (chip) =>
      !(chip.query === chipToRemove.query && chip.type === chipToRemove.type)
  );
setSearchChips(updated);
  localStorage.setItem('ledgerSearchChips', JSON.stringify(updated));  if (updated.length === 0) {
    setdisplayedLedgers(ledgers);
    setPersistedSearchQuery('');
    setPersistedSearchType('');
    return;
  }
  const last = updated[updated.length - 1];
  handleSearch(last.query, last.type);
};


const handleAddSearchChip = (query, type) => {
  if (!type) return;

  const actualQuery = query.trim();

  setSearchChips((prev) => {
    const exists = prev.some(
      (chip) => chip.query === actualQuery && chip.type === type
    );
    if (exists) return prev;

     const updated = [...prev, { query: actualQuery, type }];
    localStorage.setItem('ledgerSearchChips', JSON.stringify(updated));
    return updated;
  });

  setPersistedSearchQuery(actualQuery);
  setPersistedSearchType(type);
  handleSearch(actualQuery, type);
};


const handleChipClick = (chip) => {
  setPersistedSearchQuery(chip.query);
  setPersistedSearchType(chip.type);
  handleSearch(chip.query, chip.type);
};

 const fetchGetAllLedgers = async (attempt = 1) => {
  setIsLoading(true);

  try {
    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);
      const encryptedhubId = sessionStorage.getItem('hubId');
      const hubId = decryptData(encryptedhubId);
    const GetLedgers = `${backendApiUrl}rewards/get-all-coin-ledgers?hubId=${hubId}`; 

    const response = await fetch(GetLedgers, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      },
    });

    const data = await response.json();
    console.log('Fetch response:', response);
    console.log('Fetched data:', data);  

    if (response.ok) {
      const mappedLedgers = data.data.map(ledger => ({
        _id: ledger._id,
        customerName: ledger.consumer_id?.customer_name || 'N/A',     
        mobile: ledger.consumer_id?.mobile_number || 'N/A',         
        projectName: ledger.project_id?.projectName || 'N/A',         
        rule: ledger.ruleId?.name || 'N/A',                         
        productCategory: ledger.product_category_id?.product_category_name || 'N/A',  
        transactionType: ledger.transaction_type || 'N/A',           
        status: ledger.status || 'N/A',                              
        buildcoins: ledger.build_coins ?? 'N/A',                      
       remainingCoins: ledger.remaining_coins ?? 'N/A',          
        timestamp: ledger.createdAt || null,                          
      }));

      // Apply role-based filtering
      const filteredLedgers = filterProjects(mappedLedgers);
      setLedgers(filteredLedgers);
      setdisplayedLedgers(filteredLedgers || []);
      setIsLoading(false);
      return mappedLedgers;
    } else if (response.status === 500) {
      setShowPopup(true);
      setRetryFunction(() => () => fetchGetAllLedgers());
      setPopupType("500");
      setPopupMessage(data.message || "Internal Server Error");
      setIsLoading(false);
    } else {
      setPopupMessage(data.message || "Failed to fetch ledgers");
      setPopupType(`${response.status}`);
      setShowPopup(true);
      setIsLoading(false);
    }
  } catch (error) {
    console.error('Failed to fetch ledgers:', error);

    if (attempt < RETRY_LIMIT) {
      setRetryCount(attempt + 1);
      setTimeout(() => fetchGetAllLedgers(attempt + 1), 1000);
      setIsLoading(false);
    } else {
      setIsLoading(false);
      setPopupMessage("Internal Server Error. Kindly Retry.");
      setPopupType("500");
      setShowPopup(true);
      setRetryFunction(() => () => fetchGetAllLedgers(attempt));
    }
  }

  return [];
};

  useEffect(() => {
   fetchGetAllLedgers();
    
    
    const handleRefresh = () => {
      fetchGetAllLedgers(); 
    };
    window.addEventListener('refreshProjectList', handleRefresh);
    return () => {
      window.removeEventListener('refreshProjectList', handleRefresh);
    };
  }, []);
  





      const closePopup = () => {
       // console.log("closePopup called");
        setShowPopup(false);
      };

      const Retry = async () => {
        //console.log("Retry called");
        setIsLoading(true); // Show loader
        setTimeout(async () => {
          if (retryFunction) {
            await retryFunction();
          }
          setIsLoading(false); // Hide loader after retry
        }, 5000); // 5-second delay
        setShowPopup(false);
      };
      
      const BackToLoginPage = () => {
        //console.log("Back To Login Page");
        setShowPopup(false);
        localStorage.removeItem('LoginData');
        sessionStorage.removeItem('userData');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('userId');
        sessionStorage.removeItem('appId');
      navigate('/bb');
      };

      
      


  


if (isLoading) {
  return <Loader />;
}




  return (
  <div className="w-full h-full flex flex-col justify-between ">
    <div className="w-full h-16 border-b flex items-center">
      <div className="flex w-full justify-between px-4 mb-4 mt-3 items-center">
        {/* New container for the title and search bar */}
        <div className="flex items-center space-x-4">
          <h1 className="text-lg font-bold whitespace-nowrap">Buildcoin Ledgers</h1>
   {ledgers.length > 0 && (    
          <>
         <Search
  searchQuery={persistedSearchQuery}
  setSearchQuery={setPersistedSearchQuery}
  searchType={persistedSearchType}
  setSearchType={setPersistedSearchType}
  searchTypes={searchTypes}
  onSearch={handleSearch}
  onSearchSubmit={handleAddSearchChip}
  placeholder="Search projects..."
/>

<div className="flex flex-row items-center gap-3  whitespace-nowrap">
  {searchChips.map((chip, index) => {
    const active = chip.type === persistedSearchType;

    return (
      <div
        key={index}
        onClick={() => handleChipClick(chip)}
        className={`flex items-center px-3 py-1 rounded-full text-sm shadow-sm whitespace-nowrap ${
          active ? 'bg-red-500 text-white' : 'bg-gray-100 text-gray-800'
        }`}
      >
        <span className="font-regular">
          {chip.type}
        </span>

        <button
          className="ml-2 font-bold"
          onClick={(e) => {
            e.stopPropagation();
            handleRemoveSearchChip(chip);
          }}
        >
          ×
        </button>
      </div>
    );
  })}
</div>
</>
          )}


        </div>

        {isRefreshing && (
          <div className="ml-2 animate-spin text-[#f7525A]">↻</div>
        )}
      

  </div>
</div>

<Pagination
  currentPage={currentPage}
  totalPages={totalPages}
  totalItems={totalItems}
  itemsPerPage={10}
  showInfo={true}
    hideControls={true} 
  itemName="ledgers"
/>

  <div className="w-full h-full bg-white rounded-xs overflow-hidden">
  <div className="overflow-y-auto h-[80vh]">

  {ledgers.length === 0 ? (
          <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-8 mx-4 mt-4">
     <div className="text-center text-gray-500">
          <div className="mb-4">
            <FaCoins  className="mx-auto h-12 w-12 text-gray-300" />
          </div>
          <h3 className="text-lg font-medium mb-2">No Ledgers Found</h3>
          <p className="text-sm">Ledgers will appear once they are created.</p>
        </div>
        </div>

  ) : displayedLedgers.length === 0 && persistedSearchQuery ? (
    <div className="flex flex-col items-center justify-center py-10 text-[#6c7184] border-b">
      <FontAwesomeIcon icon={faSearch} className="text-4xl text-gray-300 mb-4" />
      <p className="text-lg font-medium mb-1">No Results Found</p>
      <p className="text-sm">Try adjusting your search criteria.</p>
    </div>

  ) : (
    /* CASE 3: Show table */
    <table className="w-full mb-5">
      <thead className="sticky top-0 bg-[#fafafc] text-[#6c7184] border-b">
        <tr className="border-b">
          <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
            <div className="flex items-center justify-center" onClick={() => sortArray('customerName')}>
              <span>Customer Name</span>
              {getSortIcon('customerName')}
            </div>
          </th>

          <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
            <div className="flex items-center justify-center" onClick={() => sortArray('mobile')}>
              <span>Mobile</span>
              {getSortIcon('mobile')}
            </div>
          </th>

          <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
            <div className="flex items-center justify-center" onClick={() => sortArray('projectName')}>
              <span>Project Name</span>
              {getSortIcon('projectName')}
            </div>
          </th>

          <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
            <div className="flex items-center justify-center" onClick={() => sortArray('rule')}>
              <span>Rule</span>
              {getSortIcon('rule')}
            </div>
          </th>

          <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
            <div className="flex items-center justify-center" onClick={() => sortArray('productCategory')}>
              <span>Product category</span>
              {getSortIcon('productCategory')}
            </div>
          </th>

          <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
            <div className="flex items-center justify-center" onClick={() => sortArray('transactionType')}>
              <span>Transaction Type</span>
              {getSortIcon('transactionType')}
            </div>
          </th>

          <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
            <div className="flex items-center justify-center" onClick={() => sortArray('status')}>
              <span>Status</span>
              {getSortIcon('status')}
            </div>
          </th>

          <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
            <div className="flex items-center justify-center" onClick={() => sortArray('buildcoins')}>
              <span>Buildcoins</span>
              {getSortIcon('buildcoins')}
            </div>
          </th>

          <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
            <div className="flex items-center justify-center" onClick={() => sortArray('remainingCoins')}>
              <span>Remaining coins</span>
              {getSortIcon('remainingCoins')}
            </div>
          </th>
        </tr>
      </thead>

      <tbody className="border-b border-t">
        {currentItems.map((ledger) => (
          <tr key={ledger._id} className="text-sm border-b">
            <td className="py-2 px-2 text-center text-sm text-gray-700">
              {ledger.customerName}
            </td>

            <td className="py-2 px-2 text-center text-sm text-gray-700">
              {ledger.mobile}
            </td>

            <td className="py-2 px-2 text-center text-sm text-gray-700">
              {ledger.projectName}
            </td>

            <td className="py-2 px-2 text-center text-sm text-gray-700">
              {ledger.rule || 'N/A'}
            </td>

            <td className="py-2 px-2 text-center text-sm text-gray-700">
              {ledger.productCategory || 'N/A'}
            </td>

            <td className="py-2 px-2 text-center text-sm text-gray-700">
              {ledger.transactionType}
            </td>

            <td className="py-2 px-2 text-center text-sm text-gray-700">
              {ledger.status}
            </td>

            <td className="py-2 px-2 text-center text-sm text-gray-700">
              {ledger.buildcoins ?? 'N/A'}
            </td>

            <td className="py-2 px-2 text-center text-sm text-gray-700">
              {ledger.remainingCoins ?? 'N/A'}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )}

</div>

</div>


             <div className="sticky bottom-0 bg-white shadow-md z-10 px-4 py-2">
<Pagination
  currentPage={currentPage}
  totalPages={totalPages}
  totalItems={totalItems}
  itemsPerPage={10}
  onPageChange={handlePageChange}
  onPreviousPage={handlePreviousPage}
  onNextPage={handleNextPage}
  showInfo={false}
  itemName="ledgers"
/>
</div>

  {showPopup && (
  <div>
    {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
    {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
    {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
          {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup} />}
  </div>
)}

  </div>
);
};

export default BuildCoinLedgers;